module.exports = __webpack_public_path__ + "static/media/excel1.96192ae2.PNG";